import React, { useState, useEffect } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';

import AuthUtility from './auth/AuthUtility';
import InfoCard from './InfoCard';
import { useOffCanvas } from '../../context/OffCanvasProvider';
import DonatePanel from '../panels//DonatePanel';

import swal from 'sweetalert';

import logo from '../../assets/frontend/images/logo_2.png';
import listeners from '../../assets/frontend/images/logo_2.png';
//import listeners from '../../assets/frontend/images/listeners.png';
import creators from '../../assets/frontend/images/creators.png';
import organizations_collaborators from '../../assets/frontend/images/organizations_collaborators.png';

import romergence_image from '../../assets/frontend/images/romergence.png';
import to_infinity_square_image from '../../assets/frontend/images/to_infinity_square.png';
import fragments_of_the_mind_square_image from '../../assets/frontend/images/fragments_of_the_mind_square.png';
import fragments_of_the_mind_square_lighter_image from '../../assets/frontend/images/fragments_of_the_mind_square_lighter.png';
import to_infinity_and_back_square_image from '../../assets/frontend/images/to_infinity_and_back_square.png';
import rise_and_fall_square_image from '../../assets/frontend/images/rise_and_fall_square.png';
import between_the_moment_square_image from '../../assets/frontend/images/between_the_moment_square.png';
import age_of_ascension_square_image from '../../assets/frontend/images/age_of_ascension_square.png';
import through_the_concrete_square_image from '../../assets/frontend/images/through_the_concrete_square.png';

const Home = () => {

	//logout should be its own component
	const navHistory = useNavigate();

	// using hooks
	const [authRole, setAuthRole] = useState(
		AuthUtility.isLoggedIn() ? localStorage.getItem('auth_role') : null
	);

	const [labelIndex, setLabelIndex] = useState(0);

	const labels = [
		{ title: "Romergence", tagline: "Out of the Abyss", flag: "🇺🇸" },
		{ title: "Romergeus", tagline: "De Ortu Abyssi", flag: "🇻🇦" },
		{ title: "Romergencia", tagline: "Del Surgir del Abismo", flag: "🇪🇸" }
	];

	const { push: openCanvas } = useOffCanvas();  // ✅ load offcanvas functions

	function handleAlbum(title_private, type) {
		if (!title_private || title_private === '' || !type || type === '') {
			return;
		}
		if (AuthUtility.isLoggedIn()) {
			navHistory('/member/album/' + title_private + '/' + type);
		} else {
			//user not authenticated on server so remove from local storage
			AuthUtility.clearAuthData();
			navHistory('/album/' + title_private + '/' + type);
		}
	}


	function openDonate(e) {
		e.stopPropagation();

		openCanvas({
			component: DonatePanel,
			props: {
				track: null,
				tracklist: null,
			}
		});
	}

	function handleJoin() {
		navHistory('/register');
	}

	function handleComingSoon(text) {

		swal("Info", text + " Coming Soon.", "info");
	}

	useEffect(() => {
		const interval = setInterval(() => {
			setLabelIndex((i) => (i + 1) % labels.length);
		}, 10000); // matches fade timing

		return () => clearInterval(interval);
	}, []);

	const currentLabel = labels[labelIndex];

	return (
		<div className={`body-content bg-fff pt-70l-110m-50s ${authRole === null || authRole === '' ? 'pb-160l-125s' : 'pb-220l-180s'}`}>

			<div className="panel large">
				<div className="grid-x">
					<div className="large-12 medium-12 small-12 cell text-center mt-20l-10s">
						<div className="text-overlay-wrapper b2-000 text-center">
							<div className="text-overlay-1020-top50 hide-for-small-only">
								<div className="position-align-top-left pt-20l-10s plr-20l-10s text-left">
									<Link to="/register" className="button medium width-120px pr-20">Join</Link>
								</div>
								<div className="position-align-top-right pt-20l-10s plr-20l-10s text-right">
									<Link className="button medium width-120px pl-20"
										onClick={(e) => openDonate(e)}
									/*onClick={() => handleComingSoon('Donate')}*/
									>
										Donate
									</Link>
								</div>
							</div>
							<div className="text-overlay-1020-bottom50">
								{/*
								<div className="position-align-bottom pb-20 text-center hide-for-small-only">
									<div className="font-orbitron font-size-24 font-weight-800 txt-fff letter-spacing-0px uppercase italic">Romergence</div>
									<div className="font-orbitron font-size-14 font-weight-500 txt-fff letter-spacing-1px italic pt-15">De Ortu Abyssi</div>
								</div>
								<div className="position-align-bottom pb-10 text-center show-for-small-only">
									<div className="font-orbitron font-size-16 font-weight-800 txt-fff letter-spacing-0px uppercase italic">Romergence</div>
									<div className="font-orbitron font-size-11 font-weight-500 txt-fff letter-spacing-1px italic pt-7">De Ortu Abyssi</div>
								</div>
								*/}
								{/* ROTATING TEXT ONLY */}
								<div className="position-align-bottom pb-20l-10s text-center">
									<span key={labelIndex} className="text-block fade-cycle">
										<div className="font-orbitron font-size-24l-20m-18s font-weight-800 txt-fff letter-spacing-0px uppercase italic">{currentLabel.title}</div>
										<div className="font-orbitron font-size-18l-14m font-weight-500 txt-fff letter-spacing-1px italic pt-10l-5s">{currentLabel.tagline}</div>
									</span>
								</div>
							</div>
							<img src={romergence_image} className="b2-000" alt="romergence image" width="100%" />
						</div>
						<div className="mt-20l-10s">
							<div className="font-poppins font-size-18l-16m font-weight-400 justify line-height-120per">
								<span className="font-orbitron font-size-18l-16m font-weight-800 letter-spacing-0px uppercase italic">Romergence</span>
								&nbsp;is a boundary-pushing music label born from the fusion of intellect, emotion, and sonic exploration.
								Inspired by
								<Link onClick={() => handleComingSoon('More About Romergence')}>... Read More</Link>
								{/*the name Romero and the concept of emergence-where complex beauty arises from the interaction of
								simple elements-Romergence bridges the personal and the universal. Its catalog weaves together themes of love
								and soul connection (<span className="font-orbitron font-weight-800 letter-spacing-0px uppercase italic">To Infinity & Back</span> ),
								the mysteries of time, space, and consciousness (<span className="font-orbitron font-weight-800 letter-spacing-0px uppercase italic">Fragments Of The Mind</span> ),
								and the cyclical nature of human history (<span className="font-orbitron font-weight-800 letter-spacing-0px uppercase italic">Rise & Fall</span> ).
								Rooted in poetic lyricism, bold concepts, and genre-blending soundscapes, Romergence exists to awaken thought, stir feeling, and resonate at the deepest
								levels of mind, body, and spirit.
								*/}
							</div>
						</div>
						<div className="horizontal-container pt-20 show-for-small-only">
							<span className="align-left">
								<Link to="/register" className="button medium width-120px">Join</Link>
							</span>
							<span className="align-right">
								<Link className="button medium width-120px"
									onClick={(e) => openDonate(e)}>
									Donate
								</Link>
							</span>
						</div>
					</div>
					<div className="large-12 medium-12 small-12 cell text-center pt-20l-10s mt-20">
						<span className="font-orbitron font-weight-800 font-size-24l-20m-16s letter-spacing-1px uppercase italic">Something For Everyone</span>
					</div>
					<div className="large-12 medium-12 small-12 cell bg-fafafa b1-ccc p-20l-10s mt-20l-10s">
						<InfoCard
							image={listeners}
							title="Listeners"
							subtitle="Listen, Discover, Be Part of the Creative Process"
							description="Dive into a world where listening meets creation. Enjoy curated radio stations, discover fresh music, and build playlists that match your vibe. But here, you're more than just a listener - you can help shape the next big hit. Vote on demo tracks, give feedback on lyrics, and share your thoughts directly with emerging artists. Every like, comment, and vote helps creators grow and evolve. Join a music community that doesn't just play songs - it creates them, together."
							url="/listeners"
						/>
					</div>
					<div className="large-12 medium-12 small-12 cell bg-fafafa b1-ccc p-20l-10s mt-20l-10s">
						<InfoCard
							image={creators}
							title="Creators"
							subtitle="Your Song Idea, Our Platform, Let’s Create"
							description="You don't need to play an instrument to bring your music to life. Start with a word, a phrase, or a simple concept, and our platform guides you step-by-step - from writing lyrics to choosing the perfect genre and sound. Collaborate with professional producers and vocalists who can shape your vision into a finished track. Approve mixes, follow the production progress, and watch your idea transform into a song that's ready to release. It's your story, your emotion - now made musical."
							url="/creators"
						/>
					</div>
					<div className="large-12 medium-12 small-12 cell bg-fafafa b1-ccc p-20l-10s mt-20l-10s">
						<InfoCard
							image={organizations_collaborators}
							title="Collaborators"
							subtitle="Create, Collaborate, and Launch Together"
							description="Bring your entire creative team under one roof - producers, vocalists, songwriters, and engineers - and build music from the ground up in one connected workspace. Manage projects, upload stems, leave time-coded feedback, and track every stage from idea to release. With built-in task management, version control, and royalty splits, your team stays perfectly in sync. Whether you're crafting a single or an entire album, your organization's studio now lives online - streamlined, secure, and ready to release to the world."
							url="/organizations_collaborators"
						/>
					</div>
					<div className="large-12 medium-12 small-12 cell text-center pt-20l-10s mt-20">
						<span className="font-orbitron font-weight-800 font-size-24l-20m-16s letter-spacing-1px uppercase italic">Albums</span>
					</div>
					<div className="large-12 medium-12 small-12 cell text-center mt-20l-10s">
						<Link onClick={() => handleComingSoon('Search')} className="button small width-200px-100per">Search Albums</Link>
					</div>
					<div className="large-12 medium-12 small-12 cell mt-20l-10s">
						<div className="grid-x">
							<div className="large-3 medium-6 small-6 cell album-hover hover-opacity-75 plr-5" onClick={() => handleAlbum('to_infinity', 'album')}>
								<div className="text-overlay-wrapper text-center">
									<div className="text-overlay-1020-bottom50">
										<div className="position-align-bottom pb-10 text-center">
											<div className="font-orbitron font-size-18l-16m-14s font-weight-800 txt-fff letter-spacing-0px uppercase italic">
												To Infinity
											</div>
										</div>
									</div>
									<img src={to_infinity_square_image} className="b2-000 hide-for-small-only" alt="romergeto_infinitynce image" width="100%" />
									<img src={to_infinity_square_image} className="b2-000 show-for-small-only" alt="to_infinity image" width="100%" />
								</div>
								<div className="pt-5 text-center">
									<button className="button small width-80pxl-70pxm-80pxs plr-20"
										onClick={() => handleAlbum('to_infinity', 'album')}>
										Listen
									</button>
								</div>
							</div>
							<div className="large-3 medium-6 small-6 cell album-hover hover-opacity-75 plr-5" onClick={() => handleAlbum('fragments_of_the_mind', 'demos')}>
								<div className="text-overlay-wrapper text-center">
									<div className="text-overlay-1020-bottom50">
										<div className="position-align-bottom pb-10 text-center">
											<div className="font-orbitron font-size-18l-16m-14s font-weight-800 txt-fff letter-spacing-0px uppercase italic">
												Framents Of
												<div className='pt-10l-5m'></div>
												The Mind
											</div>
										</div>
									</div>
									<img src={fragments_of_the_mind_square_lighter_image} className="b2-000 hide-for-small-only" alt="fragments_of_the_mind image" width="100%" />
									<img src={fragments_of_the_mind_square_lighter_image} className="b2-000 show-for-small-only" alt="fragments_of_the_mind image" width="100%" />
								</div>
								<div className="pt-5 text-center">
									<button className="button small width-80pxl-70pxm-80pxs plr-20"
										onClick={() => handleAlbum('fragments_of_the_mind', 'demos')}>
										Listen
									</button>
								</div>
							</div>
							<div className="large-3 medium-6 small-6 cell album-hover hover-opacity-75 plr-5" onClick={() => handleAlbum('to_infinity_and_back', 'album')}>
								<div className="pt-20 show-for-1020px">&nbsp;</div>
								<div className="text-overlay-wrapper text-center">
									<div className="text-overlay-1020-bottom50">
										<div className="position-align-bottom pb-10 text-center">
											<div className="font-orbitron font-size-18l-16m-14s font-weight-800 txt-fff letter-spacing-0px uppercase italic">
												To Infinity
												<div className='pt-10l-5m'></div>
												& Back
											</div>
										</div>
									</div>
									<img src={to_infinity_and_back_square_image} className="b2-000 hide-for-small-only" alt="to_infinity_and_back image" width="100%" />
									<img src={to_infinity_and_back_square_image} className="b2-000 show-for-small-only" alt="to_infinity_and_back image" width="100%" />
								</div>
								<div className="pt-5 text-center">
									<button className="button small width-80pxl-70pxm-80pxs plr-20"
										onClick={() => handleAlbum('to_infinity_and_back', 'album')}>
										Listen
									</button>
								</div>
							</div>
							<div className="large-3 medium-6 small-6 cell album-hover hover-opacity-75 plr-5l-0m" onClick={() => handleAlbum('age_of_ascension', 'demos')}>
								<div className="pt-20"></div>
								<div className="text-overlay-wrapper text-center">
									<div className="text-overlay-1020-bottom50">
										<div className="position-align-bottom pb-10 text-center">
											<div className="font-orbitron font-size-18l-16m-14s font-weight-800 txt-fff letter-spacing-0px uppercase italic">
												Age Of
												<div className="pt-10l-5m"></div>
												Ascension
											</div>
										</div>
									</div>
									<img src={age_of_ascension_square_image} className="b2-000 hide-for-small-only" alt="age_of_ascension image" width="100%" />
									<img src={age_of_ascension_square_image} className="b2-000 show-for-small-only" alt="age_of_ascension image" width="100%" />
								</div>
								<div className="pt-5 text-center">
									<button className="button small width-80pxl-70pxm-80pxs plr-20"
										onClick={() => handleAlbum('age_of_ascension', 'demos')}>
										Listen
									</button>
								</div>
							</div>
							<div className="large-3 medium-6 small-6 cell album-hover hover-opacity-75 plr-5l-0m" onClick={() => handleAlbum('rise_and_fall', 'demos')}>
								<div className="pt-20 show-for-1020px">&nbsp;</div>
								<div className="text-overlay-wrapper text-center">
									<div className="text-overlay-1020-bottom50">
										<div className="position-align-bottom pb-10 text-center">
											<div className="font-orbitron font-size-18l-16m-14s font-weight-800 txt-fff letter-spacing-0px uppercase italic">
												Rise & Fall
											</div>
										</div>
									</div>
									<img src={rise_and_fall_square_image} className="b2-000 hide-for-small-only" alt="rise_and_fall image" width="100%" />
									<img src={rise_and_fall_square_image} className="b2-000 show-for-small-only" alt="rise_and_fall image" width="100%" />
								</div>
								<div className="pt-5 text-center">
									<button className="button small width-80pxl-70pxm-80pxs plr-20"
										onClick={() => handleAlbum('rise_and_fall', 'demos')}>
										Listen
									</button>
								</div>
							</div>
							<div className="large-3 medium-6 small-6 cell album-hover hover-opacity-75 plr-5l-0m" onClick={() => handleAlbum('between_the_moment', 'album')}>
								<div className="pt-20"></div>
								<div className="text-overlay-wrapper text-center">
									<div className="text-overlay-1020-bottom50">
										<div className="position-align-bottom pb-10 text-center">
											<div className="font-orbitron font-size-18l-16m-14s font-weight-800 txt-fff letter-spacing-0px uppercase italic">
												Between The
												<div className="pt-10l-5m"></div>
												Moment
											</div>
										</div>
									</div>
									<img src={between_the_moment_square_image} className="b2-000 hide-for-small-only" alt="between_the_moment image" width="100%" />
									<img src={between_the_moment_square_image} className="b2-000 show-for-small-only" alt="between_the_moment image" width="100%" />
								</div>
								<div className="pt-5 text-center">
									<button className="button small width-80pxl-70pxm-80pxs plr-20"
										onClick={() => handleAlbum('between_the_moment', 'album')}>
										Listen
									</button>
								</div>
							</div>
							<div className="large-3 medium-6 small-6 cell album-hover hover-opacity-75 plr-5l-0m" onClick={() => handleAlbum('through_the_concrete', 'demos')}>
								<div className="pt-20"></div>
								<div className="text-overlay-wrapper text-center">
									<div className="text-overlay-1020-bottom50">
										<div className="position-align-bottom pb-10 text-center">
											<div className="font-orbitron font-size-18l-16m-14s font-weight-800 txt-fff letter-spacing-0px uppercase italic">
												Through The
												<div className="pt-10l-5m"></div>
												Concrete
											</div>
										</div>
									</div>
									<img src={through_the_concrete_square_image} className="b2-000 hide-for-small-only" alt="through_the_concrete image" width="100%" />
									<img src={through_the_concrete_square_image} className="b2-000 show-for-small-only" alt="through_the_concrete image" width="100%" />
								</div>
								<div className="pt-5 text-center">
									<button className="button small width-80pxl-70pxm-80pxs plr-20"
										onClick={() => handleAlbum('through_the_concrete', 'demos')}>
										Listen
									</button>
								</div>
							</div>

						</div>
					</div>
					<div className="large-12 medium-12 small-12 cell text-center pt-20l-10s mt-20">
						<span className="font-orbitron font-weight-800 font-size-24l-20m-16s letter-spacing-1px uppercase italic">Additional Info</span>
					</div>
					<div className="large-12 medium-12 small-12 cell text-center bg-fafafa b1-ccc mt-20l-10s">
						<table>
							<tbody>
								<tr>
									<td align="left" className="font-poppins font-size-18l-16m-14s font-weight-500"><Link onClick={() => handleComingSoon('Mission Statement')}>Mission Statement</Link></td>
								</tr>
								<tr>
									<td align="left" className="font-poppins font-size-18l-16m-14s font-weight-500"><Link onClick={() => handleComingSoon('Artist Bio')}>Artist Bio</Link></td>
								</tr>
								<tr>
									<td align="left" className="font-poppins font-size-18l-16m-14s font-weight-500"><Link onClick={() => handleComingSoon('Music Producer')}>Music Producer - Renzo Martinez</Link></td>
								</tr>
								<tr>
									<td align="left" className="font-poppins font-size-18l-16m-14s font-weight-500"><Link onClick={() => handleComingSoon('Music Producer')}>Music Producer - Matthew L</Link></td>
								</tr>
								<tr>
									<td align="left" className="font-poppins font-size-18l-16m-14s font-weight-500"><Link onClick={() => handleComingSoon('Music Producer')}>Music Producer - Richva P</Link></td>
								</tr>
								<tr>
									<td align="left" className="font-poppins font-size-18l-16m-14s font-weight-500"><Link onClick={() => handleComingSoon('Vocalist')}>Vocalist - Bobby John</Link></td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>

		</div>

	);
}

export default Home;